export default "__VITE_ASSET__m7VSOeno__"